import { Tooltip, Icon } from 'components/common';
import { colours } from 'utils/theme';
import styled from 'styled-components';

const LockContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .hidden-cell-row & {
    justify-content: flex-start;
  }
`;

export const LockedIcon = () => {
  return (
    <Tooltip
      title={
        <span>
          Upgrade your license to view locked content.{' '}
          <a href={'mailto:laura@scileads.com'}>Click here</a>.
        </span>
      }
    >
      <LockContainer>
        <Icon icon='lock' color={colours.grey} size='xl' />
      </LockContainer>
    </Tooltip>
  );
};
